// /* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import "../../_components/antd.css";
import { Table } from "antd";
// import alertify from "alertifyjs";
// import axios from "axios";
import "../../assets/css/AddedCss.css";
// import { onMessage } from "firebase/messaging";
// import NotificationDataEdit from "./NotificationDataEdit";
// import { messaging } from "../../firebase/firebase-config";

const Notification = () => {
  const [menu, setMenu] = useState(false);
  const [loading] = useState(false);
  const [error] = useState(false);
  const [TempleListMain, ] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [templeList, setTempleList] = useState([]);
  const [hideContent, setHideContent] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageSize, setPageSize] = useState(10);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



  // const timeout5 = () => {
  //   var duration = 7;
  //   alertify.set("notifier", "position", "top-right");
  //   var msg = alertify.message(
  //     "You have New Notification " + duration + " seconds.",
  //     7,
  //     function() {
  //       clearInterval(interval);
  //     }
  //   );
  //   var interval = setInterval(function() {
  //     msg.setContent("You have New Notification " + --duration + " seconds.");
  //   }, 1000);
  // };

  useEffect(() => {


  }, []);

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "title",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <h2 className="table-avatar">
          <div to="/profile" className="avatar avatar-sm me-2">
            <img
              className="avatar-img rounded-circle"
              src={`https://api.hinduconnect.net${record.image}`}
              alt="Temple Image"
            />
          </div>
          <div to="/profile">{record.title}</div>
        </h2>
      ),
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      sorter: (a, b) => a.message.localeCompare(b.message),
      render: (text) => (text.length > 100 ? `${text.slice(0, 100)}...` : text),
    },
    {
      title: "Post By",
      dataIndex: "posted_by_name",
      key: "posted_by_name",
      sorter: (a, b) => a.posted_by_name.localeCompare(b.posted_by_name),
    },
    {
      title: "Post Date",
      dataIndex: "posted_date",
      key: "posted_date",
      sorter: (a, b) => a.posted_date.localeCompare(b.posted_date),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status - b.status, // Numeric sorting
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div className="d-flex align-items-center">
          <div className="dropdown dropdown-action">
            <button
              className="btn-action-icon border-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fas fa-ellipsis-v"></i>
            </button>
            <div className="dropdown-menu dropdown-menu-right">
              <ul>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      setTempleList(record);
                      setHideContent(!hideContent);
                      setModalShow(!modalShow);
                    }}
                  >
                    <i className="far fa-eye me-2"></i>View
                  </button>
                </li>
                {/* <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      setEditTemple(record);
                      setHideContent(!hideContent);
                      setEditModal(true);
                    }}
                  >
                    <i className="far fa-edit me-2"></i>Edit
                  </button>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      ),
    },
  ];

  // Handler when page changes
  const onPageChange = (page) => {
    setCurrentPage(page); // Update the current page
  };

  const onShowSizeChange = (current, size) => {
    setPageSize(size);
  };

  const filteredTempleList = TempleListMain.filter((notification) => {
    const searchLower = searchQuery.toLowerCase();

    // Check if searchQuery exists in any of the relevant fields
    return (
      (notification.title &&
        notification.title.toLowerCase().includes(searchLower)) ||
      (notification.message &&
        notification.message.toLowerCase().includes(searchLower)) ||
      (notification.posted_by_name &&
        notification.posted_by_name.toLowerCase().includes(searchLower)) ||
      (notification.posted_date &&
        notification.posted_date.toLowerCase().includes(searchLower)) ||
      (notification.status !== undefined &&
        notification.status.toString().includes(searchLower)) // Convert status to string for comparison
    );
  });

  // Paginate filtered temples
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedTemples = filteredTempleList.slice(startIndex, endIndex);

  const exportToCSV = () => {
    if (!filteredTempleList || filteredTempleList.length === 0) {
      alert("No data to export");
      return;
    }

    const flattenedData = filteredTempleList.map((temple) => {
      return {
        id: temple.id,
        title: temple.title,
        message: temple.message,
        post_by: temple.posted_by_name,
        image: temple.image,
        post_date: temple.posted_date,
        status: temple.status,
      };
    });

    console.log("flattenedData", flattenedData);

    // Prepare CSV headers
    const headers = Object.keys(flattenedData[0]).join(",");

    // Prepare rows
    const rows = flattenedData.map((row) =>
      Object.values(row)
        .map((value) => `"${value}"`)
        .join(",")
    );

    // Combine headers and rows
    const csvContent = [headers, ...rows].join("\n");

    // Create a blob for the CSV
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Trigger the download
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "NotificationData.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        {/* {loading && <p>Loading...</p>}
        {error && <p>{error}</p>} */}
        {hideContent && (
          <div className="page-wrapper">
            <div className="content container-fluid">
              {/* Page Header */}
              <div className="page-header">
                <div className="content-page-header">
                  <h5>Notification Details</h5>
                  <div className="list-btn">
                    <ul className="filter-list">
                      <li>
                        <input
                          type="text"
                          name="search_temple"
                          placeholder="Search..."
                          className="form-control"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </li>
                      <div className="d-flex justify-content-center align-items-center">
                        <li>
                          <Link
                            to="/notificationregister"
                            className="btn btn-primary"
                          >
                            <i
                              className="fa fa-plus-circle me-2"
                              aria-hidden="true"
                            />
                            Add Notification
                          </Link>
                        </li>
                        <li>
                          <a className="btn btn-primary" onClick={exportToCSV}>
                            <i
                              className="fa fa-plus-circle me-2"
                              aria-hidden="true"
                            />
                            Export
                          </a>
                        </li>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}

              {/* Table */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="card-table">
                    <div className="card-body purchase">
                      <div className="table-responsive table-hover">
                        {loading && (
                          <div
                            className="spinner-grow text-light m-2"
                            role="status"
                          />
                        )}
                        {error && <p>{error}</p>}
                        <Table
                          pagination={{
                            total: filteredTempleList.length,
                            current: currentPage,
                            pageSize: pageSize,
                            showSizeChanger: true,
                            onChange: onPageChange,
                            onShowSizeChange: onShowSizeChange,
                          }}
                          columns={columns}
                          dataSource={paginatedTemples.map((item) => ({
                            ...item,
                            key: item.id, // Ensure each row has a unique key
                          }))}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Table */}
            </div>
          </div>
        )}

        {/* <!-- Modal 1 --> */}
        {modalShow && (
          <div className="page-wrapper">
            {templeList && (
              <div className="content container-fluid">
                <div className="page-header">
                  <div className="d-flex justify-content-start align-items-center gap-3 mb-5">
                    <button
                      type="button"
                      className="btn btn-link me-1"
                      onClick={() => {
                        setHideContent(true);
                        setModalShow(false);
                      }}
                    >
                      Back
                    </button>
                    <h5>Notification Details</h5>
                  </div>

                  <div className="card">
                    <div className="card-body">
                      <ul className="list-group list-group-flush">
                        {templeList.image && (
                          <img
                            src={`https://api.hinduconnect.net${templeList.image}`}
                            alt="Temple Image"
                            style={{ maxWidth: "100%", width: "100%" }}
                          />
                        )}
                        {templeList.title && (
                          <li className="list-group-item">
                            <h1>{templeList.title}</h1>
                          </li>
                        )}
                        {templeList.message && (
                          <li className="list-group-item">
                            {templeList.message}
                          </li>
                        )}
                        {templeList.posted_by_name && (
                          <li className="list-group-item">
                            <strong>Post By:</strong>{" "}
                            {templeList.posted_by_name}
                          </li>
                        )}
                        {templeList.posted_date && (
                          <li className="list-group-item">
                            <strong>Post Date:</strong> {templeList.posted_date}
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* <!-- Modal 2 --> */}
        {/* {EditModal && (
          <NotificationDataEdit
            editTemple={editTemple}
            setEditModal={setEditModal}
            setEditTemple={setEditTemple}
            setHideContent={setHideContent}
          />
        )} */}
      </div>
    </>
  );
};

export default Notification;
